<template>
    <CChartBar
        :data="computedDatasets"
        :options="computedOptions"
        :custom-tooltips="false"
        class="chart-dimensions"
    />
</template>

<script>
import { CChartBar } from '@coreui/vue-chartjs'
import { getColor } from '@coreui/utils'

export default {
    name: 'DChartBarSimple',
    components: { CChartBar },
    props: {
        ...CChartBar.props,
        backgroundColor: {
            type: String,
            default: 'rgba(0,0,0,.2)'
        },
        pointHoverBackgroundColor: {
            type: String,
            default: ''
        },
        dataPoints: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: '',
            required: false
        },
        labels: {
            type: Array,
            default: () => { return [] }
        },
        pointed: Boolean
    },
    computed: {
        computedDatasets () {
            return {
                labels: this.labels,
                datasets: [
                    {
                        label: null,
                        backgroundColor: getColor(this.backgroundColor),
                        pointHoverBackgroundColor: getColor(this.pointHoverBackgroundColor),
                        data: this.dataPoints,
                        barPercentage: 0.5,
                        categoryPercentage: 1
                    }
                ]
            }
        },
        computedOptions () {
            return {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        caretSize: 0
                    }
                },
                maintainAspectRatio: false,
                scales: {
                    xAxes: {
                        display: false
                    },
                    yAxes: {
                        display: false
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
    .chart-dimensions {
        width: 95%;
    }
</style>
